import React, { FunctionComponent } from "react";
import {useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  fetchLeadDistributions,
  deleteLeadDistribution,
} from "../../Services/contacts";
import TopBar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import Loading from "../../Components/Loading/Loading";
import { LEAD_DISTRIBUTOR_COLUMNS } from "../../Values/tables";
import CustomTable from "../../Components/CustomTable/CustomTable";
import styles from './LeadDistributor.module.css';
import {themeColors} from "../../Components/theme";
import { useMediaQuery } from "@material-ui/core";


type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
};

const LeadDistributor: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme
}) => {
  const dispatcher = useDispatch();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [filterData, setFilterData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [searchedItem, setsearchedItem] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [uid, setUids] = useState<any>({});
  const [clearFilterTable, setClearFilterTable] = useState(false);

  useEffect(() => {
      let data: any = [];
      let uids: { [key: string]: string } = {};
      organizationUsers?.forEach((item: any, index: number) => {
        data.push(
          `${item.user_first_name} ${item.user_last_name} -${item.user_email}`
        );
        uids[item.user_email] = item.uid;
      });
  
      setUids(uids);
    }, [organizationUsers]);

  useEffect(() => {
    if (user.organization_id) {
      const unsub = fetchLeadDistributions(user.organization_id, (data) =>
        setFilterData(data)
      );

      return () => {
        unsub();
      };
    }
  }, [user]);

  const handleDeleteLeadDistributor=(data:any,index:any)=>{
    if (window.confirm('Are you sure you want to delete this Lead Distribution Logic?')) {
      if (index !== undefined) {
        const newList = [...filterData];
        newList.splice(index, 1);
        setFilterData(newList);
        deleteLeadDistribution(
          uid,
          user.organization_id,
          newList,
          dispatcher,
        );
      }
    }
  }

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}

  return (
    <>
     <div className={styles.parent} style={{ display: "block", marginTop:isMobile?"6%":"4%",...containerStyles }}>
     {filterData === undefined && <Loading />}
      <div className={commonStyle.topBar} style={{ marginTop: "0px",...containerStyles }}>
        <TopBar
          history={history}
          title={"Lead Distribution"}
          path={"/addContacts"}
          onChange={(val) => setsearchedItem(val)}
          filterText={"Status"}
          setColumnModal={(data) => setColumnModal(data)}
          show={false}
          showStatusBox={false}
          clearFilter={handleClearFilter}
        />
      </div>
      <div className={isMobile ? commonStyle.parent : commonStyle.parentp} style={{minHeight:"450px",...containerStyles}}>
        <CustomTable
          tableColumns={LEAD_DISTRIBUTOR_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="LeadDistributor"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setSearchedItem={(val) => setsearchedItem(val)}
          handleDeleteLeadDistributor={handleDeleteLeadDistributor}
          clearFilterTable={clearFilterTable}
        />
      </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(LeadDistributor);
